module.exports = __webpack_public_path__ + "static/media/ios-wine.15e329a4.svg";